import React from 'react';
import { Analytics } from './Analytics';
import { SecureModal } from '../../components/SecureModal/SecureModal';
import { OnboardingWizard } from '../Onboarding/OnboardingWizard';
import { useOnboardingStore } from '../../store/useOnboardingStore';
import { Toaster } from 'react-hot-toast';

export const Dashboard = () => {
  const { isOpen } = useOnboardingStore();

  return (
    <>
      {/* Toaster */}
      <Toaster />

      {/* Dashboard Content */}
      <main>
        <Analytics />
      </main>

      {/* Onboarding Modal */}
      {isOpen && (
        <SecureModal preventClose={true}>
          <OnboardingWizard />
        </SecureModal>
      )}
    </>
  );
};